export const WorkFlowTypes = Object.freeze({
    AFT_FULFILMENT_CENTER: 'AFT Fulfilment Center',
    SORT_CENTER: 'Sort Center',
    DELIVERY_STATION: 'Delivery Station',
    PRIME_NOW: 'Prime Now',
    THIRD_PARTY_LOGISTICS: 'Third Party Logistics',
    VENDOR_FLEX: 'Vendor Flex',
    PRIME_NOW_3P: 'Prime Now 3P',
    VIRTUAL_DOCK: 'Virtual Dock',
    KRAKEN: 'Kraken',
    AIR: 'AIR',
    UV_NODE: 'UV Node',
    MENDEL: 'Mendel',
    P2R: 'P2R',
    RAD: 'RAD',
    DOCK_MASTER: 'Dock master'
})